import TextField from '@components/TextField';
import * as z from 'zod';

const mappings = [
  [z.string(), TextField],
  [z.boolean(), () => <div>todo: Boolean</div>],
  [z.number(), () => <div>todo: number</div>],
] as const;

export default mappings;
